<template>
<svg :class="{active: active}" width="16" height="16" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.9363 20.7516L20.1634 16.0781C19.948 15.8672 19.656 15.75 19.3496 15.75H18.5693C19.8905 14.0953 20.6756 12.0141 20.6756 9.75C20.6756 4.36406 16.2187 0 10.7182 0C5.21766 0 0.760742 4.36406 0.760742 9.75C0.760742 15.1359 5.21766 19.5 10.7182 19.5C13.0304 19.5 15.156 18.7313 16.8458 17.4375V18.2016C16.8458 18.5016 16.9655 18.7875 17.181 18.9984L21.9538 23.6719C22.4038 24.1125 23.1315 24.1125 23.5767 23.6719L24.9315 22.3453C25.3815 21.9047 25.3815 21.1922 24.9363 20.7516ZM10.7182 15.75C7.33361 15.75 4.59053 13.0688 4.59053 9.75C4.59053 6.43594 7.32883 3.75 10.7182 3.75C14.1028 3.75 16.8458 6.43125 16.8458 9.75C16.8458 13.0641 14.1075 15.75 10.7182 15.75Z" fill="#B8CDD7"/>
</svg>

</template>

<script>
export default {
props: {
  active: {
    type: Boolean,
  }
}
}
</script>

<style scoped lang="scss">
svg {
  &.active {
    path {
      fill: #333333;
    }
  }
}
</style>